<div class="image-container" [inlineSVG]='"/static/images/svg/scan_card_white.svg"'>
</div>
